import { graphql } from '@/gql';

export const SubmitPerformanceIpptResultsMutation = graphql(`
    mutation SubmitPerformanceIpptResults($input: SubmitIpptResultInput!) {
        submitIpptResult(input: $input) {
            ... on SubmitIpptResultSuccessfulResponse {
                result {
                    ...IpptAssessmentResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const IpptAssessmentResult = graphql(`
    fragment IpptAssessmentResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on IpptResult {
                ...IpptResultData
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);

const IpptResultData = graphql(`
    fragment IpptResultData on IpptResult {
        pushUps
        sitUps
        runTimeSec
        points
        pullUps
    }
`);
